<template>
  <button
    v-if="cart.order_success && cart.checkout_id && (!clicked)"
    class="btn btn-block mt-3
            add-to-cart animate__animated animate__slideInDown "
    @click="acknowledgeSuccess(cart.checkout_id); clicked=true"
  >
    <div class="details-container"><span class="d-block">Order received <i class="fal fa-check-circle"></i></span>
    </div>
  </button>
</template>

<style scoped>
.add-to-cart {
  position: fixed;
  top: 0;
  text-align: center;
  font-weight: 600;
  color: #fff;
  padding: 1rem;
  background-color: var(--user-highlight-color);
  border-color: var(--user-highlight-color);
  cursor: pointer;
  border-radius: 10rem;
  font-size: 1.3rem;
  width: 90%;
  margin: 5%;
  z-index: 10000;
}
.details-container {
  position: relative;
}

@media (min-width: 1400px) {
  .add-to-cart {
    width: 20%;
    margin-left: 40%;
    margin-bottom: 1rem;
  }
}
</style>

<script>
import menuMixin from "../../mixins/menuMixin";
import cartMixin from "../../mixins/cartMixin";
export default {
  mounted() {},
  data() {
    return { clicked: false };
  },
  methods: {},
  mixins: [menuMixin, cartMixin],
};
</script>
